export const CART_ENDPOINTS = {
    GET_CART: '/checkout/cart',
    ADD_TO_CART: '/products/add',
    GET_CARD: '/checkout/card',
} as const;
